import React, { useState } from "react";
import settings from "@settings";
import { FlexBox } from "../FlexBox";
import { calendarContainer, searchInputContainer } from "./styles";
import WeekDays from "./content/WeekDay";
import useGetTrainingTimes from "./hooks/useGetTrainingTimes";
import { useDebounceCallback } from "usehooks-ts";
import { Divider } from "../Divider";
import GenderFilter from "./components/GenderFilter";
import AgeFilter from "./components/AgeFilter";

const SportKalender: React.FC<{ categories: string[] }> = ({
  categories = [],
}) => {
  const [searchValue, setSearchValue] = useState<string>("");
  const [age, setAge] = useState<number | null>(null);
  const [gender, setGender] = useState<string>("all");
  const { trainingszeiten, ages } = useGetTrainingTimes({
    categories,
    searchValue,
    age,
    gender,
  });

  const setValue = useDebounceCallback(setSearchValue, 500);

  return (
    <div
      css={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
      }}
    >
      <div css={{ width: "100%" }}>
        <div css={searchInputContainer}>
          <label>Suche</label>
          <input
            defaultValue={searchValue}
            onChange={(e) => setValue(e.target.value)}
            placeholder="Suche ..."
          />
        </div>
        <GenderFilter gender={gender} setGender={setGender} />
        <AgeFilter ages={ages} age={age} setAge={setAge} />
        <Divider />
        <FlexBox
          direction="column"
          align="stretch"
          justify="space-between"
          gap={settings.sizes.medium}
          styles={calendarContainer}
          wrap
          hasFullWidth
        >
          <WeekDays key="weekdays" trainingszeiten={trainingszeiten} />
        </FlexBox>
      </div>
    </div>
  );
};

export default SportKalender;
